import axios from 'axios'

export interface EmailSettings {
  sender_name: string
  sender_email: string
  is_locked?: boolean
  sender_domain?: {
    id: number | null
    domain: string | null
    is_verified: boolean
  }
}

export default function useEmailSettings() {
  const { t } = useI18n()
  const notification = useNotification()

  const emailSettings = ref<EmailSettings | null>(null)
  const isLoading = ref(false)

  const getEmailSettings = async (): Promise<EmailSettings | null> => {
    isLoading.value = true
    try {
      const { data } = await axios.get('/merchants/email-settings')
      emailSettings.value = data.data
      return emailSettings.value
    } catch {
      return null
    } finally {
      isLoading.value = false
    }
  }

  const saveEmailSettings = async (settings: EmailSettings): Promise<EmailSettings | null> => {
    isLoading.value = true
    try {
      const { data } = await axios.post('/merchants/email-settings', settings)
      emailSettings.value = data.data
      notification.create('success', {
        text: t('pages.domain.sender.notifications.saveSuccess'),
        timeout: 4000
      })
      return emailSettings.value
    } catch {
      notification.create('error', {
        text: t('pages.domain.sender.notifications.saveError'),
        timeout: 4000
      })
      return null
    } finally {
      isLoading.value = false
    }
  }

  return {
    emailSettings,
    getEmailSettings,
    isLoading,
    saveEmailSettings
  }
}
